<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from "./views/home";
import {getParamFromUrl} from '@/util/common.js'

export default {
  name: "App",
  components: {
    Home
  },
  mounted() {
    const ticket = getParamFromUrl('gxdjkey')
    if (ticket) {
      this.$store.commit('UPDATE_TICKET', ticket)
    }
  }
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
